import type { XingletInterface } from '../xinglet-helpers';
import { XingletWrapper } from '../xinglet-helpers';

import type { TemplateProps } from '.';

export type TemplateFrameProps = TemplateProps;
export type TemplateFrameXinglet = XingletInterface<TemplateFrameProps>;

export const Frame = XingletWrapper<TemplateFrameProps>(
  `@xing-com/crate-lebenslauf-templates-frame`
);
